import moveBookingButtonTemplate from './move_booking_button.html';

/**
 * @ngdoc directive
 * @name BB.bbMoveBooking
 *
 * @description
 * bbMoveBooking component enables changing time of bookings when widget is initialised in a modal
 *
 <example module='BB.bbMoveBooking'>
 <bb-move-booking
    booking="bookings[0]">
 </bb-move-booking>
 </example>
 */

class bbMoveBookingCtrl {

    constructor($rootScope, $translate, $scope, $timeout, AlertService, PurchaseService, PurchaseBookingService,
                bbWidgetPage, LoadingService, MoveBookingOptions, BBWidget) {

        'ngInject';

        const injectables = {
            $rootScope,
            $translate,
            $scope,
            $timeout,
            AlertService,
            PurchaseBookingService,
            PurchaseService,
            bbWidgetPage,
            LoadingService,
            MoveBookingOptions,
            BBWidget
        };

        Object.assign(this, injectables);
    }

    $onInit() {
        this.loader = this.LoadingService.$loader(this.$scope);
    }

    /*
        a booking (basket item) must be marked as 'ready' to be moved
        some bookings may require booking questions to be answered before marking as ready
        a company may be configured to ask for a reason when moving a booking => should be answered before moving
     */

    checkBookingReadyToMove() {
        this.booking.setAskedQuestions();

        if (this.booking.ready && this.booking.canMove()) {
            if (this.MoveBookingOptions.askMoveReasons) {
                this.handleMoveReasons();
            } else {
                this.moveBooking();
            }
        } else {
            this.setLoadedAndRaiseAlert('PUBLIC_BOOKING.ITEM_DETAILS.MOVE_BOOKING_FAIL_ALERT', 'warning');
        }
    }

    /*
        a booking can be updated by the purchase booking endpoint (updates a specific booking in a purchase)
        to display bookings a query should be made to the purchase endpoint to get all bookings from a single purchase
     */

    handleMoveReasons() {
        if (this.selectedMoveReason) {
            this.moveBooking();
        } else {
            this.bbWidgetPage.decideNextPage(this.MoveBookingOptions.moveReasonRoute);
        }
    }

    moveBooking() {
        /**
         * We have to remove the event_id because otherwise the booking will not be moved.
         * This id refers to the who/what/where and if the BE recognises the given id as
         * the previous one it assumes nothing has changed and prevents the booking to
         * be moved
         *
         * TODO: if you see this and you are on v4, there's something wrong
         */
        const postData = this.booking.getPostData();
        delete postData.event_id;

        this.PurchaseBookingService
            .update(this.booking, postData)
            .then(() => this.fetchBookingTotalPurchase())
            .catch(() => this.setLoadedAndRaiseAlert('CORE.ALERTS.GENERIC', 'danger'));
    }

    fetchBookingTotalPurchase() {

        this.loader.notLoaded();

        const params = {
            url_root: this.$rootScope.bb.api_url,
            purchase_id: this.booking.purchase_ref,
            no_cache: true
        };

        this.PurchaseService
            .query(params)
            .then(purchase => this.routeToNextStep(purchase))
            .catch(() => this.setLoadedAndRaiseAlert('CORE.ALERTS.GENERIC', 'danger'));
    }

    routeToNextStep(updatedPurchase) {
        this.loader.setLoaded();
        this.BBWidget.preventPurchaseTotalRequest = true;
        this.bbWidgetPage.decideNextPage(this.MoveBookingOptions.confirmationRoute);
        // we need to use a timeout otherwise the bbTotal controller would not notice $broadcast event
        this.$timeout(() => this.$rootScope.$broadcast('booking:moved', updatedPurchase));
    }

    setLoadedAndRaiseAlert(error, type) {
        this.loader.setLoaded();
        const msg = this.$translate.instant(error);
        this.AlertService.add(type, {msg});
    }
}

const bbMoveBooking = {
    templateUrl: moveBookingButtonTemplate.id,
    controller: bbMoveBookingCtrl,
    controllerAs: '$bbMoveBookingCtrl',
    bindings: {
        booking: '<',
        moveReasons: '<',
        selectedMoveReason: '<'
    }
};

angular
    .module('BBPublicBooking')
    .component('bbMoveBooking', bbMoveBooking);
export default bbMoveBookingCtrl;




// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/public-booking/move-booking/bb_move_booking.component.js